// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2HDTB","dragIcon":"SortableItem_dragIcon__r29Jg","disabled":"SortableItem_disabled__ZvhFP"};